import { LitElement } from 'lit';

/**
 * Base class for all components in this app. Renders into light DOM so
 * global CSS (tokens, base, component styles imported via Vite) applies
 * without per-component duplication. Trades style isolation for migration
 * speed; uPlot in particular requires this since it manipulates DOM directly.
 */
export class LightElement extends LitElement {
  protected override createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }
}
